import React, { useContext } from "react";
import { Container, LoadText } from "./loader.styles";
// import DotLoader from "react-spinners/DotLoader";
import SyncLoader from "react-spinners/SyncLoader";
import CurrentQuestionContext from "../../contexts/CurrentQuestionContext";
import LoadingGif from "./loading.gif";

const Loader = ({ mounted }) => {
  const isSuccessText = useContext(CurrentQuestionContext).isSuccessText;
  return (
    <Container isMounted={mounted} isFadeOut={isSuccessText}>
      {mounted && (
        <SyncLoader size={"5vh"} color={"#5776FF"} margin={2} loading={true} />
      )}
    </Container>
  );
};

export default Loader;
